import { render, staticRenderFns } from "./hk-access.vue?vue&type=template&id=0c6d5908&scoped=true&"
import script from "./hk-access.vue?vue&type=script&lang=js&"
export * from "./hk-access.vue?vue&type=script&lang=js&"
import style0 from "./hk-access.vue?vue&type=style&index=0&id=0c6d5908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d5908",
  null
  
)

export default component.exports